const shippingFeeDetail = function (params) {
  return {
    fare_detail_id: params.id ? String(params.id) : ''
  }
}

export const trackRoutesMap = {
  '#/cms/:cms_id': {
    pageId: 4035,
    url: '/newcmspage',
    // intercepter: params => {
    //   const queries = window.location.search
    //     .slice(1)
    //     .split('&')
    //     .reduce((prev, curr) => {
    //       const [key, value] = curr.split('=')
    //       return key && value !== undefined
    //         ? Object.assign(prev, {
    //             [key]: value
    //           })
    //         : prev
    //     }, {})
    //   return queries.spm
    //     ? Object.assign(params, {
    //         spm: queries.spm
    //       })
    //     : params
    // },
    passed: 1
  },
  '#/category_area/frozen': {
    pageId: 3919,
    url: '/category_area/frozen'
  },
  '#/money_tree': {
    pageId: 3961,
    url: '/cashcow'
  },
  '#/seckillNew': {
    pageId: 820,
    url: '/seckill'
  },
  '#/app_download': {
    pageId: 4089,
    url: '/appdownload'
  },
  '#/similar_goods': {
    pageId: 4615,
    url: '/similar_goods'
  },
  '#/bill_index': {
    pageId: 4979,
    url: '/bill_index'
  },
  '#/bill_export': {
    pageId: 4981,
    url: '/bill_detail'
  },
  '#/bill_export_list': {
    pageId: 5223,
    url: '/bill_export_list'
  },
  '#/activity_goods': {
    pageId: 808,
    url: '/activity_goods'
  },
  '#/deliver_order_list': {
    pageId: 3389,
    url: '/deliver_order_list'
  },
  '#/deliver_order_detail': {
    pageId: 3390,
    url: '/deliver_order_detail'
  },
  '#/pop_index': {
    pageId: 314,
    url: '/pop_index'
  },
  '#/pop_qualification': {
    pageId: 315,
    url: '/pop_qualification'
  },
  '#/pop_license': {
    pageId: 316,
    url: '/pop_license',
    passed: 1
  },
  '#/hotSaleList': {
    pageId: 4724,
    url: '/expand_list',
    passed: 2
  },
  '#/coupon_center': {
    pageId: 3499,
    url: '/expand_list',
    passed: 2
  },
  '#/new-good-req/list': {
    pageId: 213,
    url: '/new-good-req/list'
  },
  '#/new-good-req/add': {
    pageId: 214,
    url: '/new-good-req/add'
  },
  '#/new-good-req/detail': {
    pageId: 239,
    url: '/new-good-req/detail'
  },
  '#/member/index': {
    pageId: 5051,
    url: 'member/index'
  },
  '#/member/buyList': {
    pageId: 5052,
    url: 'member/buyList'
  },
  '#/shipping-fee': {
    pageId: 196,
    url: '/shipping-fee'
  },
  '#/shipping-fee-detail': {
    pageId: 197,
    url: '/shipping-fee-detail',
    intercepter: shippingFeeDetail
  },
  '#/shipping-fee-rules': {
    pageId: 4911,
    url: '/shipping-fee-ruless'
  },
  '#/cancelorder': {
    pageId: 26,
    url: '/cancelorder'
  },
  '#/inspect-report': {
    pageId: 4154,
    url: '/inspect-report'
  },
  '#/member-integral': {
    pageId: 809,
    url: '/member-integral'
  },
  '#/member-integral-detail': {
    pageId: 416,
    url: '/member-integral-detail'
  },
  '#/member-integral-history': {
    pageId: 5072,
    url: '/member-integral-history'
  },
  '#/member-couponpack': {
    pageId: 3529,
    url: '#/member-couponpack'
  },
  '#/member-couponpack-history': {
    pageId: 3531,
    url: '#/member-couponpack-history'
  },
  '#/member-couponpack-detail': {
    pageId: 3530,
    url: '#/member-couponpack-detail'
  },
  '#/member-couponpack-success': {
    pageId: 3532,
    url: '#/member-couponpack-success'
  },
  '#/user-change-price': {
    pageId: 5167,
    url: '#/user-change-price'
  },
  '#/goods-rank': {
    pageId: 5209,
    url: '#/ranking',
    passed: 1
  },
  '#/demand-word-rank': {
    pageId: 5210,
    url: '#/product-ranking',
    passed: 1
  },
  '#/activity-area': {
    pageId: 5212,
    url: '#/activity_zone'
  },
  '#/home-goods': {
    pageId: 5228,
    url: '#/home-goods'
  },
  '#/key-box': {
    pageId: 5240,
    url: '#/key-box'
  },
  '#/key-box-detail': {
    pageId: 5234,
    url: '#/key-box-detail'
  }
}
